var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHaircare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Hair-Dress-Cut--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Hair Dress Cut Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.62 5.5h2.5a1 1 0 0 0 0 -2h-2.5a1 1 0 1 0 0 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.62 9.5h2.5a1 1 0 0 0 0 -2h-2.5a1 1 0 1 0 0 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.62 13.5h2.5a1 1 0 0 0 0 -2h-2.5a1 1 0 1 0 0 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.62 19.5a3 3 0 0 0 -3 -3 3.05 3.05 0 0 0 -1 0.18V8.06a1.07 1.07 0 0 0 0 -0.25L8.84 1a1 1 0 0 0 -0.33 -0.56L8.27 0.23A1 1 0 0 0 7 0.23l-0.26 0.21a1 1 0 0 0 -0.33 0.56L4.66 7.81a1.09 1.09 0 0 0 0 0.25v8.62a3 3 0 0 0 -1 -0.18 3 3 0 1 0 3 3v-4.68a0.28 0.28 0 0 1 0.09 -0.19l1.5 -1.31a0.25 0.25 0 0 1 0.41 0.19v6A3 3 0 0 0 11 22.43 3 3 0 0 0 13.62 24a1 1 0 0 0 0 -2 0.92 0.92 0 0 1 -0.28 -0.05 3 3 0 0 0 1.28 -2.45Zm-11 1a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1ZM7 11.68a0.24 0.24 0 0 1 -0.27 0 0.25 0.25 0 0 1 -0.15 -0.23V8.19l1 -3.91 1 3.91v2a0.27 0.27 0 0 1 -0.08 0.19Zm4.58 6.82a1 1 0 1 1 -1 1 1 1 0 0 1 1.04 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.38 2.75A2.75 2.75 0 0 0 20.63 0h-5a1 1 0 1 0 0 2h4a0.26 0.26 0 0 1 0.26 0.25v12.5a0.26 0.26 0 0 1 -0.26 0.25h-4a1 1 0 1 0 0 2h4a0.26 0.26 0 0 1 0.26 0.25v5a1.75 1.75 0 1 0 3.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHaircare);
export default ForwardRef;